import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "./Config"; // Import the base URL
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ForgetPassEmail() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setStatus("Please enter your email");
      setShowToast(true);
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/forgot_password.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const result = await res.json();

      console.log(result);

      if (result.success) {
        setStatus("✅ Reset code sent to your email.");
        setTimeout(() => {
          navigate("/verify-email", { state: { email } });
        }, 1500);
      } else {
        setStatus("❌ " + result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus("❌ Something went wrong. Try again.");
    }

    setShowToast(true);
    setLoading(false);
  };

  return (
    <>
      <div className="container pb-5">
        <div className="row">
          <div className="col-12 pt-5">
            <div className="logo">
              <Link to="/">
                <img
                  src={`${BASE_URL}/images/fastrade_logo.jpg`}
                  style={{ width: "220px" }}
                  alt="Fast Trade "
                />
              </Link>
            </div>
          </div>
          <div className="col-12 pt-4">
            <div className="login-form">
              <form onSubmit={handleSubmit}>
                <div className="form-page">
                  {showToast && (
                    <div className="status-message alert alert-info">
                      {status}
                    </div>
                  )}

                  <h2>Forgot your password?</h2>
                  <p style={{ marginTop: "15px" }}>
                    Use phone instead?{" "}
                    <Link
                      to="/forget-pass"
                      className="redirect_link"
                      style={{ fontWeight: "600" }}
                    >
                      Reset via SMS
                    </Link>
                  </p>

                  <div className="inputs pt-3">
                    <input
                      type="email"
                      placeholder="Enter Registered Email"
                      className="number_input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="submit-btn pt-3">
                    <input
                      type="submit"
                      value={loading ? "Sending..." : "Send Code"}
                      className="btn btn-primary"
                      style={{
                        width: "100%",
                        backgroundColor: "#128DE5",
                        padding: "10px",
                        marginBottom: "15px",
                        fontWeight: "600",
                      }}
                      disabled={loading}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
